import React, { Component } from "react";
import { Skeleton, PageHeader, Typography, Row, Col, message } from "antd";
import Editor from "../../components/Editor/Editor";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import BoardApis from "../../../../utils/boardApis";

const { Title } = Typography;

export class PostAddPage extends Component {
  render() {
    return (
      <Skeleton loading={false} active>
        <PageHeader title={<Title level={2}>게시글 등록하기</Title>} />
        <div className="admin-page-content">
          <Row>
            <Col>
              <Editor
                type={"add"}
                hasType={true}
                orgId={this.props.orgId}
                // onSaved={data => {
                //   this.props.history.push("/admin/board");
                // }}
                onSubmit={data => {
                  BoardApis.addPost(data).then(r => {
                    message.success("저장 성공");
                    this.props.history.push("/admin/board");
                  });
                }}
                onBack={() => {
                  this.props.history.push("/admin/board");
                }}
              />
            </Col>
          </Row>
        </div>
      </Skeleton>
    );
  }
}

export default withRouter(
  connect(
    ({ auth }) => ({
      pending: auth.pending,
      auth: auth,
      orgId: auth.user.orgId
    }),
    null
  )(PostAddPage)
);
